import React from 'react';
import { CenteredLoadingIndicator, Modal } from '@spotify-internal/anchor-ds';
import { ButtonPrimary, Type, spacer24 } from '@spotify-internal/encore-web';
import { FetchSpotifyAccountResponse } from 'client/modules/AnchorAPI/v3/spotifyConnect/fetchSpotifyAccount';
import { useT } from 'i18n/hooks/useT';
import styled from 'styled-components';
import { SpotifyConnectAvatarIcon } from './SpotifyConnectAvatarIcon';

type SpotifyConnectSuccessModalProps = {
  onContinue: () => void;
  onClose: () => void;
  accountInfo?: FetchSpotifyAccountResponse;
  isLoading: boolean;
};

const AccountInfoWrapper = styled(Modal.Body)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const AvatarIconWrapper = styled.span`
  margin: ${spacer24};
`;

export const SpotifyConnectSuccessModal = ({
  accountInfo,
  onContinue,
  onClose,
  isLoading,
}: SpotifyConnectSuccessModalProps) => {
  const t = useT();

  const [{ url: avatarUrl } = { url: undefined }] = accountInfo?.images ?? [];
  const displayName = accountInfo?.displayName ?? 'Display Name';

  return (
    <Modal
      isShowingCloseButton={!isLoading}
      onClose={onClose}
      aria-labelledby="spotify-connect-success-modal-title"
    >
      <Modal.Title id="spotify-connect-success-modal-title">
        {t(
          'SpotifyAccountConnectSuccessModal.Title',
          'Spotify Account linked to Anchor!',
          'Spotify Account is now linked to Anchor'
        )}
      </Modal.Title>
      {isLoading ? (
        <CenteredLoadingIndicator />
      ) : (
        <AccountInfoWrapper>
          <AvatarIconWrapper>
            <SpotifyConnectAvatarIcon
              avatarUrl={avatarUrl}
              displayName={displayName}
              size={124}
            />
          </AvatarIconWrapper>
          <Type variant="cello">{displayName}</Type>
        </AccountInfoWrapper>
      )}
      <Modal.Footer>
        <ButtonPrimary onClick={onContinue} disabled={isLoading}>
          {t('Button.Continue', 'Continue', 'Continue button text')}
        </ButtonPrimary>
      </Modal.Footer>
    </Modal>
  );
};
